export default __webpack_public_path__ + "static/N0053-62f9e60f2d0a54940b8265a3a3b99bdb.png";